export const CONTRACT_NEW = 'CONTRACT_NEW';
export const CONTRACT_UPDATE = 'CONTRACT_UPDATE';
export function newContract(type: string): { type: string; payload: any } {
	return {
		type: CONTRACT_NEW,
		payload: { type },
	};
}

export function updateContract(payload: any): { type: string; payload: any } {
	return {
		type: CONTRACT_UPDATE,
		payload,
	};
}
